export const StateBlock = ({ icon: Icon, title, description, action, testId }) => (
  <div data-testid={testId} className="er-card flex flex-col items-start gap-3 text-left">
    {Icon ? <Icon size={22} className="text-sage-600" /> : null}
    <h4 className="text-lg font-medium text-ink-700">{title}</h4>
    {description ? <p className="text-sm text-ink-500 leading-relaxed">{description}</p> : null}
    {action}
  </div>
);

export const Loading = ({ label = "Carregando…", testId = "loading-state" }) => (
  <div data-testid={testId} className="flex items-center gap-3 p-6 text-sm text-ink-500">
    <span className="h-4 w-4 animate-spin rounded-full border-2 border-sage-600 border-t-transparent" />
    {label}
  </div>
);

export const Pill = ({ tone = "neutral", children, testId }) => {
  const tones = {
    neutral: "bg-sand text-ink-600",
    success: "bg-success/12 text-success",
    warning: "bg-warning/15 text-[#8A6216]",
    danger: "bg-danger/12 text-danger",
    info: "bg-info/12 text-info",
  };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${tones[tone]}`}
    >
      {children}
    </span>
  );
};
